// extracted by mini-css-extract-plugin
export default {"icon":"SelectMultipleDropdown_icon__wFLSb","select":"SelectMultipleDropdown_select__21dEL"};